import Vue from 'vue'

import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
import VueLocalStorage from 'vue-localstorage'

import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

import VueSVGIcon from 'vue-svgicon'

import App from './App.vue'
import router from './router'
import store from './store'

import 'vuetify/dist/vuetify.min.css'

delete Icon.Default.prototype._getIconUrl

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(Vuetify, {
  theme: {
    primary: '#2a63d5',
    secondary: '#2a63d5',
    accent: '#2a63d5'
  }
})
Vue.use(VueSVGIcon)
Vue.use(VueLocalStorage, {
  name: 'storage'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
